import { defineMessage, defineMessages } from "react-intl";

// The customer's "Integration" screen (change adopt-installation-per-customer, design D14 item 4):
// English is the source catalog; pt-BR is kept in sync by `pnpm i18n:extract`.

export const integrationMessages = defineMessages({
  nav: { id: "integration.nav", defaultMessage: "Integration" },
  title: { id: "integration.title", defaultMessage: "Integration" },
  subtitle: {
    id: "integration.subtitle",
    defaultMessage:
      "Configure how your operator connects to S-Trust in this installation and issue its API credentials.",
  },
  operator: { id: "integration.operator", defaultMessage: "Operator" },
  tabs: { id: "integration.tabs", defaultMessage: "Integration sections" },
  tabProducts: { id: "integration.tab.products", defaultMessage: "Products and checks" },
  tabCredentials: { id: "integration.tab.credentials", defaultMessage: "API credentials" },
  tabEnvironment: { id: "integration.tab.environment", defaultMessage: "Environment" },
  tabOrigins: { id: "integration.tab.origins", defaultMessage: "Origins" },
  noAccessTitle: {
    id: "integration.noAccess.title",
    defaultMessage: "Integration is not available",
  },
  noAccessDescription: {
    id: "integration.noAccess.description",
    defaultMessage:
      "Only an Administrator of an operator configures it and issues its API credentials, in the operator's own installation.",
  },
  deactivatedTitle: {
    id: "integration.deactivated.title",
    defaultMessage: "This operator is deactivated",
  },
  deactivatedDescription: {
    id: "integration.deactivated.description",
    defaultMessage:
      "Its configuration can no longer be changed and its API credentials are revoked.",
  },
  secretWarning: {
    id: "integration.secret.warning",
    defaultMessage:
      "Store the secret in your own secrets manager and configure your backend with it. Nobody at S-Trust sees it, and it cannot be shown again: if it is lost, create a new credential and revoke this one.",
  },
  rotationHint: {
    id: "integration.credentials.rotationHint",
    defaultMessage:
      "To rotate: create a second credential, move your backend to it, then revoke the first one. At most two credentials are active at a time.",
  },
});

/** The operator being configured and the installation's environment. */
export const operatorEnvironmentMessage = defineMessage<{ operator: string; environment: string }>(
  {
    id: "integration.operatorEnvironment",
    defaultMessage: "{operator} · {environment} installation",
  },
  { typed: true },
);
